import { giphyBlue, giphyLightCharcoal, giphyLightestGrey } from '@giphy/js-brand'
import styled from 'styled-components'
import { BORDER_RADIUS_SMALL } from '../constants'

export const Title = styled.div`
    font-size: 24px;
    font-weight: 900;
    margin: 0 0 20px;
    text-align: inherit;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;

    span {
        color: ${giphyLightestGrey};
        font-size: 15px;
        font-weight: normal;
    }
`

export const TitleSmall = styled(Title)`
    font-size: 17px;
    margin: 0 0 10px;
`

export const Subtitle = styled.div`
    font-size: 15px;
    font-weight: bold;
    margin: 0 0 10px;
    text-align: inherit;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;

    svg {
        height: 16px;
        vertical-align: top;
    }

    i {
        color: ${giphyLightCharcoal};
        font-size: 14px;
        font-weight: normal;
        vertical-align: middle;
    }

    i,
    svg {
        display: inline-block;
        margin-right: 8px;
    }
`

export const Text = styled.p`
    line-height: 1.3;
    margin: 0 0 12px;
    max-width: 400px;
    text-align: inherit;

    a {
        color: ${giphyBlue};
    }
`

export const TextSmall = styled(Text as any)`
    font-size: 14px;
`

export const TextInput = styled.div`
    align-items: center;
    background: #fff;
    border-radius: ${BORDER_RADIUS_SMALL}px;
    display: flex;
    height: 50px;
    padding: 0 12px;

    input[type='text'],
    input[type='url'] {
        border-radius: inherit;
        height: 50px;
        margin: 0;
        padding: 0;
        width: 100%;
    }
`
